import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { asyncGet } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import FormFeed from "../form/feed/FormFeed";

interface IModalViewFeed {
  postId: string;
}

function ModalViewFeed({ postId }: IModalViewFeed) {
  const { token } = useSelector((state: any) => state.auth);
  const [open, setOpen] = useState<boolean>(false);
  const [post, setPost] = useState<any>();

  const handleClose = () => {
    setOpen(false);
  };

  const getPost = async () => {
    const resp = await asyncGet({ apiCode: "posts", id: postId, token });
    if (resp && resp.status === 200) {
      setPost(resp?.data);
    } else {
      setPost(undefined);
    }
  };

  useEffect(() => {
    if (postId) {
      getPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId, open]);

  return (
    <>
      {open && (
        <FormFeed
          isEdit
          open={open}
          onClose={handleClose}
          apiCode="posts"
          defaultValues={post}
        />
      )}
      <Button
        onClick={() => setOpen(true)}
        variant="outlined"
        size="small"
        sx={{ textTransform: "none" }}
      >
        Xem bài viết
      </Button>
    </>
  );
}

export default ModalViewFeed;
